import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { type PropsWithChildren, Suspense } from 'react';

export const SuspendedWithSpinner = ({ children }: PropsWithChildren) => (
    <div data-testid='suspended-spinner'>
        <Suspense fallback={<Spinner isFullSized />}>{children}</Suspense>
    </div>
);
